import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { font, greys } from 'assets/themes/theme-default'
import { Button } from '../../index'

const StyledButton = styled(Button)`
  &&& {
    background-color: ${props => props.theme.colors.color1.bg};
    border-width: 0;
    line-height: unset;
    color: ${greys.light4};
    i {
      font-size: ${font.size.lg};
    }
    .anticon-loading {
      svg {
        fill: ${greys.light4};
      }
    }
    span {
      font-size: ${font.size.base};
    }
    :disabled {
      opacity: 0.5;
    }
  }
`

const ButtonPrimary = props => {
  const { children } = props

  return (
    <StyledButton {...props} data-test="component-primary-button">
      {children}
    </StyledButton>
  )
}

ButtonPrimary.propTypes = {
  children: PropTypes.any
}

export default ButtonPrimary
